module.exports = __webpack_public_path__ + "static/media/Ppr.23f283d8.png";